import { useProductDetailsForArray } from '../v2/hooks/product/useProductDetails';

/**
 * This hook is used to determine if the Commerce Hub product experience should be shown.
 * The Commerce Hub product experience is the new Commerce Hub page with Merch Cards.
 */
export const useCommerceHub = () => {
  var _productDetails$produ;
  const {
    productDetails,
    loading
  } = useProductDetailsForArray({
    productApiNames: ['commerce-hub-professional', 'commerce-hub-enterprise']
  });
  const hasCommerceHubSkus = Object.keys((_productDetails$produ = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ !== void 0 ? _productDetails$produ : {}).length > 0;
  return {
    loading,
    showCommerceHub: hasCommerceHubSkus
  };
};